import React from "react";
import { Outlet, NavLink } from "react-router-dom";
import { Box, Typography, Paper } from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import DescriptionIcon from "@mui/icons-material/Description";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";

const settingsNav = [
  { text: "Audit Logs", path: "/settings/audit-logs", icon: <ListAltIcon fontSize="small" /> },
  { text: "Job Document Config", path: "/settings/job-document-config", icon: <DescriptionIcon fontSize="small" /> },
  { text: "Interview Automation", path: "/settings/interview-automation", icon: <RecordVoiceOverIcon fontSize="small" /> },
];

const Settings = () => {
  return (
    <Box sx={{ py: 3 }}>
      {/* Page header */}
      <Paper
        elevation={0}
        sx={{
          border: "1px solid #E5E7EB",
          borderRadius: 2,
          p: 3,
          mb: 3,
        }}
      >
        <Typography variant="h5" fontWeight={700} color="text.primary">
          Workspace Settings
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={0.5}>
          Manage platform configuration, access control, and review audit logs.
        </Typography>
      </Paper>

      {/* Body: inner sidebar + content */}
      <Box sx={{ display: "flex", gap: 3, alignItems: "flex-start" }}>
        {/* Inner settings sidebar */}
        <Paper
          elevation={0}
          sx={{
            border: "1px solid #E5E7EB",
            borderRadius: 2,
            minWidth: 220,
            py: 1,
            flexShrink: 0,
          }}
        >
          {settingsNav.map(({ text, path, icon }) => (
            <NavLink
              key={path}
              to={path}
              style={{ textDecoration: "none" }}
            >
              {({ isActive }) => (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    px: 2,
                    py: 1.25,
                    mx: 1,
                    my: 0.25,
                    borderRadius: 1.5,
                    backgroundColor: isActive ? "#EBF2FF" : "transparent",
                    color: isActive ? "#1E40AF" : "#6B7280",
                    fontWeight: isActive ? 600 : 500,
                    fontSize: "0.875rem",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: isActive ? "#EBF2FF" : "#F3F4F6",
                      color: isActive ? "#1E40AF" : "#374151",
                    },
                    transition: "all 0.15s ease",
                  }}
                >
                  {icon}
                  <Typography
                    variant="body2"
                    fontWeight="inherit"
                    color="inherit"
                  >
                    {text}
                  </Typography>
                </Box>
              )}
            </NavLink>
          ))}
        </Paper>

        {/* Content area */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Settings;
